import axiosInstance from "@/lib/axiosInstance";
import type { CustomAxiosRequestConfig } from "@/types/common.types";
import type { AuditHistoryResponse, AuditLog } from "./auditHistory.types";

export const auditHistoryEndpoints = {
  history: "/audit/history",
  personHistory: (userId: string) => `/audit/users/${userId}/history`,
};

/**
 * The endpoint's own ceiling (`getAuditHistorySchema`: `limit` is `.max(100)`), and the whole page
 * we ever ask for. A History tab shows one line per *change*, which a single audit row can hold
 * dozens of, so the two cannot be paged in step — the history is read once and paged in the
 * browser instead.
 */
export const AUDIT_HISTORY_LIMIT = 100;

export const getAuditHistory = async (
  resourceType: string,
  resourceId: string,
  signal?: AbortSignal,
): Promise<{ logs: AuditLog[]; total: number }> => {
  const { data } = await axiosInstance.get<AuditHistoryResponse>(auditHistoryEndpoints.history, {
    params: { resourceType, resourceId, limit: AUDIT_HISTORY_LIMIT },
    signal,
    suppressErrorAlert: true,
  } as CustomAxiosRequestConfig);

  return { logs: data.data?.logs ?? [], total: data.data?.total ?? 0 };
};
